import { render, staticRenderFns } from "./DeleteDoctor.vue?vue&type=template&id=15622c11&scoped=true"
import script from "./DeleteDoctor.vue?vue&type=script&lang=js"
export * from "./DeleteDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15622c11",
  null
  
)

export default component.exports